import type { MessageTemplateDto } from '@shared/core/message-templates'
import type { GetProfileResponseDto } from '@shared/core/users'
import { ms } from '@shared/util'

export type BookingReminderSettingsProfileSource = Pick<GetProfileResponseDto, 'full_name' | 'default_message_template'>

export function getBookingReminderSettingsDefaultValues(
  profile: BookingReminderSettingsProfileSource | undefined,
  defaultTemplate: MessageTemplateDto | undefined,
) {
  const profileTemplate = profile?.default_message_template
  const timingOffsets = defaultTemplate?.reminder_offsets ?? profileTemplate?.reminder_offsets

  return {
    sendReminders: true,
    from: profile?.full_name || defaultTemplate?.sender_name || profileTemplate?.sender_name || '',
    location: defaultTemplate?.location ?? profileTemplate?.location ?? '',
    reminderMessage: defaultTemplate?.reminder_message ?? profileTemplate?.reminder_message ?? '',
    timing: (timingOffsets?.length ? timingOffsets : [ms('1d')]).map(String),
    appointmentConfirmation: true,
  }
}

export function getPopulatedMessageTemplateDefaults(profile: GetProfileResponseDto) {
  const template = profile.default_message_template
  return {
    from: template?.sender_name ?? '',
    location: template?.location ?? '',
    reminderMessage: template?.reminder_message ?? '',
    timing: (template?.reminder_offsets ?? []).map(String),
  }
}
